import { useCallback, useEffect, useState } from 'react'

export const useClickOutside = (callbackFn: () => void) => {
  const [node, setNode] = useState<HTMLElement | null>(null)

  const handleClickOutside = useCallback(
    (e: MouseEvent | TouchEvent) => {
      if (!!node && !node.contains(e.target as Element)) {
        callbackFn()
      }
    },
    [node]
  )

  useEffect(() => {
    if (node) {
      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('touchstart', handleClickOutside)

      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
        document.removeEventListener('touchstart', handleClickOutside)
      }
    }

    return () => null
  }, [node])

  const nodeRef = useCallback((node: HTMLElement | null) => setNode(node), [])

  return [nodeRef]
}
